var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{class:_vm.backgroundClassName},[_c('div',{attrs:{"id":"core-view"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{staticClass:"ma-0 pa-0"})],1)],1),_c('core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }